"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranscodeProcessing = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _Processing = require("./Processing/Processing");
var _FailedProcessing = require("./FailedProcessing/FailedProcessing");
var _constant = require("./constant");
var TranscodeProcessing = exports.TranscodeProcessing = function TranscodeProcessing(props) {
  var status = props.status,
    onRetry = props.onRetry,
    theme = props.theme,
    tooltipText = props.tooltipText,
    canRetry = props.canRetry,
    onSourceDeleted = props.onSourceDeleted;
  var displayComponent = function displayComponent() {
    if (status === _constant.FAILED) return /*#__PURE__*/_react["default"].createElement(_FailedProcessing.FailedProcessing, {
      onRetry: onRetry,
      canRetry: canRetry,
      onSourceDeleted: onSourceDeleted
    });
    if (status === _constant.PROCESSING) return /*#__PURE__*/_react["default"].createElement(_Processing.Processing, {
      theme: theme,
      tooltipText: tooltipText
    });
    return null;
  };
  return displayComponent();
};
TranscodeProcessing.propTypes = {
  tooltipText: _propTypes.string,
  status: _propTypes.string,
  theme: (0, _propTypes.oneOf)([_constant.DARK, _constant.LIGHT]),
  onRetry: _propTypes.func,
  canRetry: _propTypes.bool
};